<div class="wrap wrapMain">
  <div>
    <span *ngIf="contactInfo" class="optional">{{ contactInfo.type }}</span>
    <h1 *ngIf="contactInfo">{{ contactInfo.firstName + ' ' + contactInfo.lastName }}</h1>
    <div class="basic-checkbox basic-label" *ngIf="childMode">
      <div class="checkbox">
        <input
          #sameAddress
          class="checkbox__input"
          type="checkbox"
          id="sameEmail"
          [checked]="useSameAddress"
          (change)="changeSameAddress(sameAddress.checked)"
        />
        <div class="label-basic">
          <label for="sameEmail" class="label-basic__text checkbox__label">Same address as owner</label>
        </div>
      </div>
    </div>
  </div>
  <form class="personForm" id="contactForm" [formGroup]="contactFormGroup">
    <div class="split-row-col2">
      <fieldset class="address">
        <div class="formElem street">
          <basic-text-input
            [inputType]="'text'"
            [parserType]="'Text'"
            [propertyName]="'street'"
            type="text"
            formControlName="street"
            placeholder="Address line 1"
          ></basic-text-input>
          <control-messages [control]="contactFormGroup.controls.street"></control-messages>
        </div>

        <div class="formElem line2">
          <basic-text-input
            [inputType]="'text'"
            [parserType]="'Text'"
            [propertyName]="'line2'"
            type="text"
            formControlName="line2"
            placeholder="Address line 3"
          ></basic-text-input>
        </div>

        <div class="formElem state">
          <select-basic
            [propertyName]="'state'"
            [label]="'State'"
            [optionValues]="stateList"
            formControlName="state"
            [formGroupComponent]="true"
          ></select-basic>
        </div>

        <div class="formElem phone">
          <basic-text-input
            [inputType]="'text'"
            [parserType]="'Text'"
            [propertyName]="'phone'"
            type="text"
            id="phone"
            name="phone"
            formControlName="phone"
            placeholder="Phone Number"
            #phone
            (blur)="phone.value = formatPhone(phone.value)"
            (focus)="phone.value = removeSymbols(phone.value)"
          ></basic-text-input>
          <control-messages [control]="contactFormGroup.controls.phone"></control-messages>
        </div>
      </fieldset>
      <fieldset class="address">
        <div class="formElem line1">
          <basic-text-input
            [inputType]="'text'"
            [parserType]="'Text'"
            [propertyName]="'line1'"
            type="text"
            formControlName="line1"
            placeholder="Address line 2"
          ></basic-text-input>
        </div>

        <div class="formElem city">
          <basic-text-input
            [inputType]="'text'"
            [parserType]="'Text'"
            [propertyName]="'city'"
            type="text"
            id="city"
            formControlName="city"
            placeholder="City"
          ></basic-text-input>
          <control-messages [control]="contactFormGroup.controls.city"></control-messages>
        </div>

        <div class="formElem zip">
          <basic-text-input
            [inputType]="'text'"
            [parserType]="'text'"
            [propertyName]="'zip'"
            type="text"
            formControlName="zip"
            placeholder="ZIP"
            #zip
            (blur)="zipCodeLookup(zip.value)"
            (valueChanged)="zipCodeLookup(zip.value)"
          ></basic-text-input>
          <control-messages [control]="contactFormGroup.controls.zip"></control-messages>
        </div>
      </fieldset>
    </div>
  </form>
</div>
